// src/sections/Contact.jsx
import { useGSAP } from "@gsap/react";
import AnimatedHeaderSection from "../components/AnimatedHeaderSection";
import { ContactForm } from "../components/ContactForm";
import { socials } from "../constants";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const Contact = () => {
  const text = `Got a question, how or project idea?
I’d love to hear from you and discuss further!`;

  useGSAP(() => {
    gsap.from(".social-link", {
      y: 100,
      opacity: 0,
      delay: 0.5,
      duration: 1,
      stagger: 0.3,
      ease: "back.out",
      scrollTrigger: {
        trigger: ".social-link",
      },
    });
  }, []);

  return (
    <section
      id="contact"
      className="flex flex-col min-h-screen bg-[#e5e5e0] py-12"
    >
      <AnimatedHeaderSection
        subTitle={"Let me know how I can help"}
        title={"Contact"}
        text={text}
        textColor={"text-black"}
        withScrollTrigger={true}
      />

      {/* Contact Form */}
      <div className="px-6 md:px-10 mt-8">
        <ContactForm />
      </div>

      {/* Social Links */}
      <div className="px-6 md:px-10 font-light text-black uppercase lg:text-[32px] text-[26px] leading-none mt-12">
        <div className="flex flex-col w-full gap-10">
          {/* EMAIL */}
          <div className="social-link">
            <h2>E-mail</h2>
            <div className="w-full h-px my-2 bg-black/30" />
            <a
              href="mailto:teferafiratolesayas@gmail.com"
              className="text-xl lowercase md:text-2xl lg:text-3xl hover:underline text-black"
            >
              teferafiratolesayas@gmail.com
            </a>
          </div>

          {/* PHONE */}
          <div className="social-link">
            <h2>Phone</h2>
            <div className="w-full h-px my-2 bg-black/30" />
            <p className="text-xl lowercase md:text-2xl lg:text-3xl text-black">
              +251963535322 / +251917985105
            </p>
          </div>

          {/* SOCIAL ICONS */}
          <div className="social-link flex gap-6">
            {socials.map((social, index) => {
              const Icon = social.icon;

              return (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-2xl text-black hover:scale-110 transition-transform duration-200"
                  aria-label={social.name}
                >
                  {Icon && <Icon />}
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
